import { useState } from 'react'
import Cookies from 'universal-cookie'

const useLoggedInCookie = () => {
  const cookies = new Cookies()
  const loggedInKey = 'FWOLoggedIn'
  const cookieDomain = '.fairwork.gov.au'
  const loggedInKeyValue = '1'
  const loggedOutKeyValue = '0'
  const options = {
    path: '/',
    maxAge: 1000000,
    domain: cookieDomain,
  }

  const [, setItemValue] = useState(() => {
    if (cookies.get(loggedInKey)) {
      return cookies.get(loggedInKey)
    }
    return null
  })

  const setLoggedInCookie = () => {
    setItemValue(loggedInKeyValue)
    cookies.set(loggedInKey, loggedInKeyValue, options)
  }

  const removeLoggedInCookie = () => {
    setItemValue(loggedOutKeyValue)
    cookies.set(loggedInKey, loggedOutKeyValue, options)
  }

  return [setLoggedInCookie, removeLoggedInCookie] as const
}

export default useLoggedInCookie
